import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./Resources.css";
import "./HomePage.css";
import PageHeader from "./components/PageHeader.js";

export default function Impact() {
  const [goal, setGoal] = useState("Increase local business revenue by improving conversion on the landing page.");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [result, setResult] = useState(null);

  const run = async () => {
    try {
      setError("");
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL || "";
      const endpoint = apiUrl ? `${apiUrl}/impact/simulate` : "/impact/simulate";
      const resp = await axios.post(endpoint, {
        goal,
        context: [{ product: "Zolaid", note: "Prototype impact simulator" }],
      });
      setResult(resp.data || null);
    } catch (e) {
      console.error("impact simulate failed:", e);
      setError(e?.response?.data?.error || "Simulation failed.");
      setResult(null);
    } finally {
      setLoading(false);
    }
  };

  const sim = result?.result;

  return (
    <div className="resources-page">
      <PageHeader
        customNav={[
          { label: "Resources", to: "/Resources" },
          { label: "Roadmap", to: "/Roadmap" },
          { label: "Templates", to: "/Templates" },
        ]}
      />

      <div className="resources-content">
        <h1>Impact Simulator (Prototype)</h1>
        <p className="resources-subtitle">
          Enter a macro goal. Zolaid simulates outcomes, risks, and opportunities.
        </p>

        <section style={sectionStyle}>
          <h2>Goal</h2>
          <textarea value={goal} onChange={(e) => setGoal(e.target.value)} rows={5} style={textareaStyle} />
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 10 }}>
            <button className="generate-btn" type="button" onClick={run} disabled={loading || !goal.trim()}>
              {loading ? "Simulating..." : "Simulate"}
            </button>
          </div>
          {error && <div style={{ marginTop: 10, color: "#ffb4b4", fontSize: 12 }}>{error}</div>}
        </section>

        {sim && (
          <section style={sectionStyle}>
            <h2>Results</h2>
            <div style={{ color: "rgba(255,255,255,0.85)", fontSize: 13 }}>
              <div><strong>Scenario:</strong> {sim.scenario}</div>
              <div style={{ marginTop: 8 }}><strong>Summary:</strong> {sim.summary}</div>
            </div>

            <div style={{ marginTop: 12 }}>
              <h3>Predicted outcomes</h3>
              <ul>
                {(sim.predictedOutcomes || []).map((o, idx) => (
                  <li key={`o_${idx}`}>
                    <strong>{o.type}</strong> ({o.likelihood}): {o.description}
                  </li>
                ))}
              </ul>
            </div>

            <div style={{ marginTop: 12 }}>
              <h3>Risks</h3>
              <ul>
                {(sim.risks || []).map((r, idx) => (
                  <li key={`r_${idx}`}>
                    ({r.impact}/{r.likelihood}) {r.description}
                  </li>
                ))}
              </ul>
            </div>

            <div style={{ marginTop: 12 }}>
              <h3>Opportunities</h3>
              <ul>
                {(sim.opportunities || []).map((o, idx) => (
                  <li key={`p_${idx}`}>
                    ({o.potentialBenefit}) {o.description}
                  </li>
                ))}
              </ul>
            </div>
          </section>
        )}
      </div>

      <footer className="resources-footer">
        <p>© 2025 ZOLAID. All rights reserved.</p>
        <div className="footer-links">
          <Link to="/PrivacyPolicy">Privacy Policy</Link>
          <span>|</span>
          <Link to="/TermsOfService">Terms of Service</Link>
          <span>|</span>
          <Link to="/Contact">Contact</Link>
        </div>
      </footer>
    </div>
  );
}

const sectionStyle = {
  padding: "14px 16px",
  borderRadius: 14,
  border: "1px solid rgba(255,255,255,0.10)",
  background: "rgba(255,255,255,0.04)",
  marginBottom: 12,
};

const textareaStyle = {
  width: "100%",
  padding: "10px 12px",
  borderRadius: 12,
  border: "1px solid rgba(255,255,255,0.12)",
  background: "rgba(0,0,0,0.18)",
  color: "#ffffff",
  outline: "none",
};

